export enum PROVIDER_POSTBACK_PARAM {
  CAMPAIGN_ID = 'campaign_id',
  CLICK_ID = 'click_id',
  EVENT_ID = 'event_id',
  OFFER_ID = 'offer_id',
  SITE_ID = 'site_id',
  RANDOM = 'random',
  SERIAL = 'serial',
}
